import { useSelector } from 'react-redux';
import { selectBreadcrumbs } from '@app/redux/features/breadcrumbsSlice';
import { Link } from 'react-router-dom';
import { Fragment, useMemo } from 'react';
import { BreadCrumbIcon, BreadCrumbType } from '@entities/util/IBreadCrumb';
import IconViaBtc from '@shared/icons/IconViaBtc';
import IconHisting from '@shared/icons/IconHosting';

const Breadcrumbs = () => {
  const value = useSelector(selectBreadcrumbs);

  const path = useMemo(() => {
    return value
      ? value.map((item, index) => {
          const isLast = index === value.length - 1;

          return (
            <Fragment key={index}>
              {item.icon ? (
                <>
                  {item.icon === BreadCrumbIcon.VIA_BTC ? (
                    <span className="pr-[5px]">
                      <div className="rounded-[10px] w-[24px] h-[24px] bg-[#211F24] inline-block relative">
                        <span className="ml-[6px]">
                          <IconViaBtc width={14} height={14} fill="#959595" />
                        </span>
                      </div>
                    </span>
                  ) : null}
                  {item.icon === BreadCrumbIcon.HOSTING ? (
                    <span className="pr-[5px]">
                      <div className="rounded-[10px] w-[24px] h-[24px] bg-[#211F24] inline-block relative">
                        <span className="ml-[6px]">
                          <IconHisting width={14} height={14} fill="#959595" />
                        </span>
                      </div>
                    </span>
                  ) : null}
                </>
              ) : null}
              {item.type === BreadCrumbType.LINK && item.link ? (
                <Link to={item.link} reloadDocument>
                  {item.title}
                </Link>
              ) : isLast ? (
                <span className="text-[white]">{item.title}</span>
              ) : (
                item.title
              )}
              {!isLast ? <span className="px-[10px]">/</span> : ''}
            </Fragment>
          );
        })
      : null;
  }, [value]);

  return <div className="text-[#959595] flex items-center">{path}</div>;
};

export default Breadcrumbs;
